import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UpStorage = function (_NebulaModuleBase) {
    _inherits(UpStorage, _NebulaModuleBase);

    function UpStorage() {
        _classCallCheck(this, UpStorage);

        return _possibleConstructorReturn(this, (UpStorage.__proto__ || Object.getPrototypeOf(UpStorage)).apply(this, arguments));
    }

    _createClass(UpStorage, [{
        key: 'putFloatValue',
        value: function putFloatValue(data) {
            return this.generatePromiseByFunctionWithParams('putFloatValueForStorage', data);
        }
    }, {
        key: 'getFloatValue',
        value: function getFloatValue(data) {
            return this.generatePromiseByFunctionWithParams('getFloatValueForStorage', data);
        }
    }, {
        key: 'getFloatSubNodes',
        value: function getFloatSubNodes(data) {
            return this.generatePromiseByFunctionWithParams('getFloatSubNodesForStorage', data);
        }
    }, {
        key: 'putIntegerValue',
        value: function putIntegerValue(data) {
            return this.generatePromiseByFunctionWithParams('putIntegerValueForStorage', data);
        }
    }, {
        key: 'getIntegerValue',
        value: function getIntegerValue(data) {
            return this.generatePromiseByFunctionWithParams('getIntegerValueForStorage', data);
        }
    }, {
        key: 'getIntegerSubNodes',
        value: function getIntegerSubNodes(data) {
            return this.generatePromiseByFunctionWithParams('getIntegerSubNodesForStorage', data);
        }
    }, {
        key: 'putLongValue',
        value: function putLongValue(data) {
            return this.generatePromiseByFunctionWithParams('putLongValueForStorage', data);
        }
    }, {
        key: 'getLongValue',
        value: function getLongValue(data) {
            return this.generatePromiseByFunctionWithParams('getLongValueForStorage', data);
        }
    }, {
        key: 'getLongSubNodes',
        value: function getLongSubNodes(data) {
            return this.generatePromiseByFunctionWithParams('getLongSubNodesForStorage', data);
        }
    }, {
        key: 'putDoubleValue',
        value: function putDoubleValue(data) {
            return this.generatePromiseByFunctionWithParams('putDoubleValueForStorage', data);
        }
    }, {
        key: 'getDoubleValue',
        value: function getDoubleValue(data) {
            return this.generatePromiseByFunctionWithParams('getDoubleValueForStorage', data);
        }
    }, {
        key: 'getDoubleSubNodes',
        value: function getDoubleSubNodes(data) {
            return this.generatePromiseByFunctionWithParams('getDoubleSubNodesForStorage', data);
        }
    }, {
        key: 'putBooleanValue',
        value: function putBooleanValue(data) {
            return this.generatePromiseByFunctionWithParams('putBooleanValueForStorage', data);
        }
    }, {
        key: 'getBooleanValue',
        value: function getBooleanValue(data) {
            return this.generatePromiseByFunctionWithParams('getBooleanValueForStorage', data);
        }
    }, {
        key: 'getBooleanSubNodes',
        value: function getBooleanSubNodes(data) {
            return this.generatePromiseByFunctionWithParams('getBooleanSubNodesForStorage', data);
        }
    }, {
        key: 'putStringValue',
        value: function putStringValue(data) {
            return this.generatePromiseByFunctionWithParams('putStringValueForStorage', data);
        }
    }, {
        key: 'getStringValue',
        value: function getStringValue(data) {
            return this.generatePromiseByFunctionWithParams('getStringValueForStorage', data);
        }
    }, {
        key: 'getStringSubNodes',
        value: function getStringSubNodes(data) {
            return this.generatePromiseByFunctionWithParams('getStringSubNodesForStorage', data);
        }
    }, {
        key: 'setTemporaryStorage',
        value: function setTemporaryStorage(data) {
            return this.generatePromiseByFunctionWithParams('setTemporaryStorageForStorage', data);
        }
    }, {
        key: 'getTemporaryStorage',
        value: function getTemporaryStorage(data) {
            return this.generatePromiseByFunctionWithParams('getTemporaryStorageForStorage', data);
        }
    }, {
        key: 'deleteNode',
        value: function deleteNode(data) {
            return this.generatePromiseByFunctionWithParams('deleteNodeForStorage', data);
        }
    }, {
        key: 'deleteTemporaryStorage',
        value: function deleteTemporaryStorage(data) {
            return this.generatePromiseByFunctionWithParams('deleteTemporaryStorageForStorage', data);
        }
    }, {
        key: 'clearTemporaryStorage',
        value: function clearTemporaryStorage() {
            return this.generatePromiseByFunctionWithParams('clearTemporaryStorageForStorage', null);
        }
    }, {
        key: 'addDataListener',
        value: function addDataListener(data, listener) {
            var event = 'DataChange_' + data.key;
            var params = {
                eventName: event,
                key: data.key
            };
            return this.generatePromiseByAttachListenerWithParams(event, listener, 'addDataListenerForStorage', params);
        }
    }, {
        key: 'removeDataListener',
        value: function removeDataListener(data, listener) {
            var event = 'DataChange_' + data.key;
            var params = {
                eventName: event,
                key: data.key
            };
            return this.generatePromiseByDetachListenerWithParams(event, listener, 'removeDataListenerForStorage', params);
        }
    }, {
        key: 'removeNodeListener',
        value: function removeNodeListener(data, listener) {
            var eventName = 'NodeChange_' + data.storageName;
            var params = {
                eventName: eventName,
                storageName: data.storageName
            };
            return this.generatePromiseByDetachListenerWithParams(eventName, listener, 'removeNodeListenerForStorage', params);
        }
    }, {
        key: 'addNodeListener',
        value: function addNodeListener(data, listener) {
            var eventName = 'NodeChange_' + data.storageName;
            var params = {
                eventName: eventName,
                storageName: data.storageName
            };
            return this.generatePromiseByAttachListenerWithParams(eventName, listener, 'addNodeListenerForStorage', params);
        }
    }]);

    return UpStorage;
}(NebulaModuleBase);